const storeData = {
    "type": "FeatureCollection",
    "features": [{
            "geometry": {
                "type": "Point",
                "coordinates": [
                  -112.18313521358503,
                  33.46029286544497
                ]
            },
            "type": "Feature",
            "properties": {
                "category": "gb-point",
                "description": "",
                "name": "Phoenix",
                "phone": "",
                "state": "Arizona",
                "manager": "Jadd Dabbas",
                "job": "Hub Manager",
                "street": "5701 West Latham Street,",
                "address": "800.300.7417 ext.325",
                "zip-code": "AZ 85043",
                "mail": "j.dabbas@metropolitanwarehouse.com",
                "storeid": "01"
            }
        },
        {
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -117.5583321,
                    33.9913662
                ]
            },
            "type": "Feature",
            "properties": {
                "category": "gb-point",
                "description": "",
                "name": "Eastvale",
                "phone": "",
                "state": "California",
                "manager": "Todd Voda",
                "job": "Hub Manager",
                "street": "5055 Goodman Way,",
                "address": "",
                "zip-code": "CA 91752",
                "mail": "",
                "storeid": "02"
            }
        },
        {
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -122.1349624,
                    37.6495503
                ]
            },
            "type": "Feature",
            "properties": {
                "category": "gb-point",
                "description": "",
                "name": "Hayward",
                "phone": "",
                "state": "California",
                "manager": "Jose Cano",
                "job": "General Manager",
                "street": "2301 Lincoln Avenue",
                "address": "800.300.7417 ext. 328",
                "zip-code": "CA 94545",
                "mail": "J.Cano@metropolitanwarehouse.com",
                "storeid": "03"
            }
        },
        {
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -117.57780439018133,
                    34.035614895235234
                ]
            },
            "type": "Feature",
            "properties": {
                "category": "gb-point",
                "description": "",
                "name": "Ontario",
                "phone": "",
                "state": "California",
                "manager": "",
                "job": "",
                "street": "2155 Excise Avenue,",
                "address": "",
                "zip-code": "CA 91761",
                "mail": "",
                "storeid": "04"
            }
        },
        {
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -72.7291302,
                    41.8634444
                ]
            },
            "type": "Feature",
            "properties": {
                "category": "gb-point",
                "description": "",
                "name": "Bloomfield",
                "phone": "",
                "state": "Connecticut",
                "manager": "Justin Cheney",
                "job": "Hub Manager",
                "street": "400 Woodland Avenue,",
                "address": "",
                "zip-code": "CT 06002",
                "mail": "",
                "storeid": "05"
            }
        },
        {
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -104.8272471,
                    39.7685811
                ]
            },
            "type": "Feature",
            "properties": {
                "category": "gb-point",
                "description": "",
                "name": "Aurora",
                "phone": "",
                "state": "Colorado",
                "manager": "Gabriel Ekabua",
                "job": "Terminal Manager",
                "street": "13801 East 33rd Place,",
                "address": "800.300.7417 ext. 108",
                "zip-code": "CO 80011",
                "mail": "gabriel@metropolitanwarehouse.com",
                "storeid": "06"
            }
        },
        {
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -81.5685154,
                    30.1849942
                ]
            },
            "type": "Feature",
            "properties": {
                "category": "gb-point",
                "description": "",
                "name": "Jacksonville",
                "phone": "",
                "state": "Florida",
                "manager": "Vinny Maia",
                "job": "Terminal Manager",
                "street": "9855-101 Mining Dr.,",
                "address": "800.300.7417",
                "zip-code": "FL 32257",
                "mail": "vin@metropolitanwarehouse.com",
                "storeid": "07"
            }
        },
        {
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -80.3828536,
                    25.8702821
                ]
            },
            "type": "Feature",
            "properties": {
                "category": "gb-point",
                "description": "",
                "name": "Miami",
                "phone": "",
                "state": "Florida",
                "manager": "Ami Mizrahi",
                "job": "Hub Manager",
                "street": "11255 N.W. 106th St.,",
                "address": "",
                "zip-code": "FL 33178",
                "mail": "a.mizrahi@metropolitanwarehouse.com",
                "storeid": "08"
            }
        },
        {
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -80.3133148,
                    27.1655841
                ]
            },
            "type": "Feature",
            "properties": {
                "category": "gb-point",
                "description": "",
                "name": "Palm City",
                "phone": "",
                "state": "Florida",
                "manager": "Denny Rackett",
                "job": "Terminal Manager",
                "street": "3270 S.W. 42nd Ave.,",
                "address": "800.300.7417",
                "zip-code": "FL 34990",
                "mail": "denny@MetropolitanWarehouse.com",
                "storeid": "09"
            }
        },
        {
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -82.4245153,
                    27.9479578
                ]
            },
            "type": "Feature",
            "properties": {
                "category": "gb-point",
                "description": "",
                "name": "Tampa",
                "phone": "",
                "state": "Florida",
                "manager": "Mike Rackett",
                "job": "",
                "street": "101 South 34th Street,",
                "address": "",
                "zip-code": "FL 33605",
                "mail": "m.rackett@metropolitanwarehouse.com",
                "storeid": "10"
            }
        },
        {
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -84.2634507,
                    33.920995
                ]
            },
            "type": "Feature",
            "properties": {
                "category": "gb-point",
                "description": "",
                "name": "Atlanta",
                "phone": "",
                "state": "Georgia",
                "manager": "Branden Plotner",
                "job": "Terminal Manager",
                "street": "2775 Bankers Industrial Drive NW,",
                "address": "800.300.7417",
                "zip-code": "GA 30360",
                "mail": "b.plotner@metropolitanwarehouse.com",
                "storeid": "11"
            }
        },
        {
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -81.3592179,
                    31.7714612
                ]
            },
            "type": "Feature",
            "properties": {
                "category": "gb-point",
                "description": "",
                "name": "Savannah",
                "phone": "",
                "state": "Georgia",
                "manager": "",
                "job": "",
                "street": "1254 Island Highway, Midway,",
                "address": "",
                "zip-code": "GA 31320",
                "mail": "",
                "storeid": "12"
            }
        },
        {
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -88.0084046,
                    41.6199093
                ]
            },
            "type": "Feature",
            "properties": {
                "category": "gb-point",
                "description": "",
                "name": "Lockport",
                "phone": "",
                "state": "Illinois",
                "manager": "Heather Kellogg",
                "job": "Hub Manager",
                "street": "15901 W. 147th Street,",
                "address": "",
                "zip-code": "IL 60491",
                "mail": "",
                "storeid": "13"
            }
        },
        {
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -90.137428,
                    29.9625115
                ]
            },
            "type": "Feature",
            "properties": {
                "category": "gb-point",
                "description": "",
                "name": "New Orleans",
                "phone": "",
                "state": "Louisiana",
                "manager": "John Arizmendez",
                "job": "Hub Manager",
                "street": "300 Jefferson Highway,",
                "address": "",
                "zip-code": "LA 70121",
                "mail": "",
                "storeid": "14"
            }
        },
        {
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -71.1300046,
                    41.9467634
                ]
            },
            "type": "Feature",
            "properties": {
                "category": "gb-point",
                "description": "",
                "name": "Taunton",
                "phone": "",
                "state": "Massachusetts",
                "manager": "Ryan Cordeiro",
                "job": "Terminal Manager",
                "street": "295 Constitution Drive,",
                "address": "800.300.7417",
                "zip-code": "MA 02780",
                "mail": "r.jimenez@metropolitanwarehouse.com",
                "storeid": "15"
            }
        },
        {
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -88.7242562,
                    34.2258482
                ]
            },
            "type": "Feature",
            "properties": {
                "category": "gb-point",
                "description": "",
                "name": "Tupelo",
                "phone": "",
                "state": "Mississippi",
                "manager": "Kenny Wilson",
                "job": "Hub Manager",
                "street": "2180 Hutchinson St.,",
                "address": "",
                "zip-code": "MS 38801",
                "mail": "",
                "storeid": "16"
            }
        },
        {
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -93.1774038,
                    45.1430225
                ]
            },
            "type": "Feature",
            "properties": {
                "category": "gb-point",
                "description": "",
                "name": "Circle Pines",
                "phone": "",
                "state": "Minnesota",
                "manager": "",
                "job": "",
                "street": "3787 95th Avenue, NE#140,",
                "address": "",
                "zip-code": "MN 550141",
                "mail": "",
                "storeid": "17"
            }
        },
        {
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -115.1943457,
                    36.090455
                ]
            },
            "type": "Feature",
            "type": "Feature",
            "properties": {
                "category": "gb-point",
                "description": "",
                "name": "Las Vegas",
                "phone": "",
                "state": "Nevada",
                "manager": "Frank Recchio",
                "job": "Hub Manager",
                "street": "3950 West Diablo Drive,",
                "address": "",
                "zip-code": "NV 89118",
                "mail": "",
                "storeid": "18"
            }
        },
        {
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -76.7547778,
                    39.196576
                ]
            },
            "type": "Feature",
            "type": "Feature",
            "properties": {
                "category": "gb-point",
                "description": "",
                "name": "Elkridge",
                "phone": "",
                "state": "Maryland",
                "manager": "William Colson",
                "job": "Terminal Manager",
                "street": "7150 Troy Hill Drive",
                "address": "",
                "zip-code": "MD 21075",
                "mail": "w.colson@metropolitanwarehouse.com",
                "storeid": "19"
            }
        },
        {
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -94.4960387,
                    39.0588812
                ]
            },
            "type": "Feature",
            "type": "Feature",
            "properties": {
                "category": "gb-point",
                "description": "",
                "name": "Kansas City",
                "phone": "",
                "state": "Missouri",
                "manager": "Rusty Black",
                "job": "Hub Manager",
                "street": "3522 Enterprise Drive",
                "address": "",
                "zip-code": "MO 64129",
                "mail": "rusty@metropolitanwarehouse.com",
                "storeid": "20"
            }
        },
        {
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -90.4676116,
                    38.7746655
                ]
            },
            "type": "Feature",
            "type": "Feature",
            "properties": {
                "category": "gb-point",
                "description": "",
                "name": "Earth City",
                "phone": "",
                "state": "Missouri",
                "manager": "Sean Jansen",
                "job": "Hub Manager",
                "street": "4349 Green Ash",
                "address": "",
                "zip-code": "MO 64129",
                "mail": "",
                "storeid": "21"
            }
        },
        {
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -111.999007,
                    46.6006946
                ]
            },
            "type": "Feature",
            "type": "Feature",
            "properties": {
                "category": "gb-point",
                "description": "",
                "name": "Helena",
                "phone": "",
                "state": "Montana",
                "manager": "Ryan Murgel",
                "job": "Hub Manager",
                "street": "1500 Blaine Street",
                "address": "",
                "zip-code": "MT 59601",
                "mail": "",
                "storeid": "22"
            }
        },
        {
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -83.3238727,
                    42.2357751
                ]
            },
            "type": "Feature",
            "type": "Feature",
            "properties": {
                "category": "gb-point",
                "description": "",
                "name": "Romulus",
                "phone": "",
                "state": "Michigan",
                "manager": "Tyler Fuller",
                "job": "Hub Manager",
                "street": "28825-28873 Highland Road, Building 7, Airport Park",
                "address": "",
                "zip-code": "MI 48174",
                "mail": "",
                "storeid": "23"
            }
        },
        {
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -80.0149646,
                    35.9393597
                ]
            },
            "type": "Feature",
            "type": "Feature",
            "properties": {
                "category": "gb-point",
                "description": "",
                "name": "High Point Ward Avenue",
                "phone": "",
                "state": "North Carolina",
                "manager": "",
                "job": "",
                "street": "741 W.Ward Ave.",
                "address": "",
                "zip-code": "NC 27260",
                "mail": "",
                "storeid": "24"
            }
        },
        {
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -80.0051972,
                    35.8906727
                ]
            },
            "type": "Feature",
            "type": "Feature",
            "properties": {
                "category": "gb-point",
                "description": "",
                "name": "Archdale",
                "phone": "",
                "state": "North Carolina",
                "manager": "",
                "job": "",
                "street": "5265 Surrett Drive",
                "address": "",
                "zip-code": "NC 27263",
                "mail": "",
                "storeid": "25"
            }
        },
        {
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -79.9562576,
                    36.0421829
                ]
            },
            "type": "Feature",
            "type": "Feature",
            "properties": {
                "category": "gb-point",
                "description": "",
                "name": "High Point Eagle Drive",
                "phone": "",
                "state": "North Carolina",
                "manager": "",
                "job": "",
                "street": "4193 Eagle Hill Drive",
                "address": "",
                "zip-code": "NC 27265",
                "mail": "",
                "storeid": "26"
            }
        },
        {
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -80.93751,
                    35.1277469
                ]
            },
            "type": "Feature",
            "type": "Feature",
            "properties": {
                "category": "gb-point",
                "description": "",
                "name": "Charlotte",
                "phone": "",
                "state": "North Carolina",
                "manager": "",
                "job": "",
                "street": "1814 Westinghouse Boulevard",
                "address": "",
                "zip-code": "NC 28273",
                "mail": "",
                "storeid": "27"
            }
        },
        {
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -74.2633124,
                    40.5278056
                ]
            },
            "type": "Feature",
            "type": "Feature",
            "properties": {
                "category": "gb-point",
                "description": "",
                "name": "Perth Amboy",
                "phone": "",
                "state": "New Jersey",
                "manager": "",
                "job": "",
                "street": "960 High Street",
                "address": "",
                "zip-code": "NJ 08861",
                "mail": "",
                "storeid": "28"
            }
        },
        {
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -75.3522427,
                    39.7714094
                ]
            },
            "type": "Feature",
            "type": "Feature",
            "properties": {
                "category": "gb-point",
                "description": "",
                "name": "Township",
                "phone": "",
                "state": "New Jersey",
                "manager": "",
                "job": "",
                "street": "4-Killdeer Court, Logan",
                "address": "",
                "zip-code": "NJ 08085",
                "mail": "",
                "storeid": "29"
            }
        },
        {
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -76.3374927,
                    43.0881383
                ]
            },
            "type": "Feature",
            "type": "Feature",
            "properties": {
                "category": "gb-point",
                "description": "",
                "name": "Warners",
                "phone": "",
                "state": "New York",
                "manager": "",
                "job": "",
                "street": "2511 Warners Road",
                "address": "",
                "zip-code": "NY 13164",
                "mail": "",
                "storeid": "30"
            }
        },
        {
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -77.7583955,
                    43.1564821
                ]
            },
            "type": "Feature",
            "type": "Feature",
            "properties": {
                "category": "gb-point",
                "description": "",
                "name": "Rochester",
                "phone": "",
                "state": "New York",
                "manager": "",
                "job": "",
                "street": "30 Vantage Point Drive",
                "address": "",
                "zip-code": "NY 14624",
                "mail": "",
                "storeid": "32"
            }
        },
        {
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -83.0565327,
                    39.8821869
                ]
            },
            "type": "Feature",
            "type": "Feature",
            "properties": {
                "category": "gb-point",
                "description": "",
                "name": "Columbus",
                "phone": "",
                "state": "Ohio",
                "manager": "",
                "job": "",
                "street": "3940 Gantz Road",
                "address": "",
                "zip-code": "OH 43123",
                "mail": "",
                "storeid": "33"
            }
        },
        {
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -84.3782675,
                    39.2533347
                ]
            },
            "type": "Feature",
            "type": "Feature",
            "properties": {
                "category": "gb-point",
                "description": "",
                "name": "Blue Ash",
                "phone": "",
                "state": "Ohio",
                "manager": "",
                "job": "",
                "street": "4750 Lake Forest Drive",
                "address": "",
                "zip-code": "OH 45242",
                "mail": "",
                "storeid": "34"
            }
        },
        {
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -122.4995057,
                    45.5601691
                ]
            },
            "type": "Feature",
            "type": "Feature",
            "properties": {
                "category": "gb-point",
                "description": "",
                "name": "Portland",
                "phone": "",
                "state": "Oregon",
                "manager": "",
                "job": "",
                "street": "158th Commerce Park, 16137 & 16143 NE Cameron",
                "address": "",
                "zip-code": "OR 97230",
                "mail": "",
                "storeid": "35"
            }
        },
        {
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -86.5883634,
                    36.0037863
                ]
            },
            "type": "Feature",
            "type": "Feature",
            "properties": {
                "category": "gb-point",
                "description": "",
                "name": "La Vergne",
                "phone": "",
                "state": "Tennessee",
                "manager": "",
                "job": "",
                "street": "274 Mason Road",
                "address": "",
                "zip-code": "TN 37086",
                "mail": "",
                "storeid": "36"
            }
        },
        {
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -95.4934165,
                    29.6147824
                ]
            },
            "type": "Feature",
            "type": "Feature",
            "properties": {
                "category": "gb-point",
                "description": "",
                "name": "HOUSTON",
                "phone": "",
                "state": "Texas",
                "manager": "",
                "job": "",
                "street": "14453 Hillcroft",
                "address": "",
                "zip-code": "TX 77085",
                "mail": "",
                "storeid": "37"
            }
        },
        {
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -97.0060263,
                    32.9482383
                ]
            },
            "type": "Feature",
            "type": "Feature",
            "properties": {
                "category": "gb-point",
                "description": "",
                "name": "Coppell",
                "phone": "",
                "state": "Texas",
                "manager": "",
                "job": "",
                "street": "435 Southwestern Boulevard",
                "address": "",
                "zip-code": "TX 75019",
                "mail": "",
                "storeid": "38"
            }
        },
        {
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -97.6567167,
                    30.3266594
                ]
            },
            "type": "Feature",
            "type": "Feature",
            "properties": {
                "category": "gb-point",
                "description": "",
                "name": "AUSTIN",
                "phone": "",
                "state": "Texas",
                "manager": "",
                "job": "",
                "street": "8301 Springdale Road",
                "address": "",
                "zip-code": "TX 78724",
                "mail": "",
                "storeid": "39"
            }
        },
        {
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -111.982722,
                    40.7408928
                ]
            },
            "type": "Feature",
            "type": "Feature",
            "properties": {
                "category": "gb-point",
                "description": "",
                "name": "Salt Lake City",
                "phone": "",
                "state": "Utah",
                "manager": "",
                "job": "",
                "street": "3505 West California Avenue",
                "address": "",
                "zip-code": "UT 84104",
                "mail": "",
                "storeid": "41"
            }
        },
        {
            "geometry": {
                "type": "Point",
                "coordinates": [
                    -122.2277347,
                    47.4146951
                ]
            },
            "type": "Feature",
            "type": "Feature",
            "properties": {
                "category": "gb-point",
                "description": "",
                "name": "Kent",
                "phone": "",
                "state": "Washington",
                "manager": "",
                "job": "",
                "street": "8451 S 208th St",
                "address": "",
                "zip-code": "WA 98031",
                "mail": "",
                "storeid": "42"
            }
        }
    ]
  }